module.exports = __webpack_public_path__ + "img/1586368689.8bac6328.jpg";